import * as S from './GoTribeDetailUI.styles';

const GoTribeDetailUI = ({persuationData = []}) => {
  return (
    <>
      {
        <S.GoTriberBannerWrapper>
          <S.GoTriberBannerImage src={persuationData?.[0]?.imageUrl} />
          <S.MainContent>
            <S.GoTribeLeftBlockDiv>
              <S.GoTribeTextBlockDiv>
                <S.GoTribeBoldTextSpan
                  bgColor={persuationData?.[1]?.colourCodeData?.bgColour}
                  textColor={persuationData?.[1]?.colourCodeData?.textColour}
                  dangerouslySetInnerHTML={{
                    __html: persuationData?.[1]?.persuasionText,
                  }}
                />
              </S.GoTribeTextBlockDiv>
            </S.GoTribeLeftBlockDiv>
          </S.MainContent>
        </S.GoTriberBannerWrapper>
      }
    </>
  );
};

export default GoTribeDetailUI;
